/* eslint-disable no-restricted-imports */
import { useLocation, useSearchParams } from 'react-router-dom';
import { HIDE_TABBAR_PARAM } from '../../../../constant';
import { useGetDialogState } from '../../../../routing/ModalRoute';
import { DIALOGS } from '../../../../routing/constants';

/** Показываем стаб на страницах, где есть фиксированный элемент внизу страницы */
export const useShowBottomStub = () => {
    const { pathname } = useLocation();
    const [query] = useSearchParams();
    const dialogState = useGetDialogState();

    const isFavoritesPage = pathname.includes('/collections/-1');
    const hideTabbarParam = query.get(HIDE_TABBAR_PARAM) === '1';
    const subscriptionsDialog = dialogState === DIALOGS.SUBSCRIPTIONS;

    return !isFavoritesPage && !hideTabbarParam && !subscriptionsDialog;
};
